import { Controller } from "@hotwired/stimulus";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export default class extends Controller {
  static values = {
    applicantPhone: String,
    targetInputId: String,
  };

  static targets = ["confirmationWrapper", "checkbox", "checkboxLabel"];

  connect() {
    const phoneInput = this.getPhoneInput();

    if (phoneInput) {
      phoneInput.addEventListener("change", this.handleChange.bind(this));
    } else {
      console.warn("Phone input not found");
    }
  }

  getPhoneInput() {
    return document.getElementById(this.targetInputIdValue);
  }

  handleChange(event) {
    const normalizedPhone = parsePhoneNumberFromString(event.target.value, "US");

    if (normalizedPhone?.number === this.applicantPhoneValue) {
      this.checkboxTarget.required = true;
      this.checkboxLabelTarget.classList.add("required");
      this.confirmationWrapperTarget.hidden = false;
    } else {
      this.checkboxTarget.required = false;
      this.checkboxLabelTarget.classList.remove("required");
      this.confirmationWrapperTarget.hidden = true;
      this.checkboxTarget.checked = false;
    }
  }
}
